import { render, staticRenderFns } from "./InformacionTarea.vue?vue&type=template&id=15324c7d"
import script from "./InformacionTarea.vue?vue&type=script&lang=js"
export * from "./InformacionTarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports